import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// GET /api/inventory/orders/:id — getOrderById(). Full detail: vendor + lines (each with
// its `item` and `reservations`).
//
// Moved from src/hooks/fetch-hooks/get-purchase-order-detail/fetch-purchase-order-detail.js
// onto the v2 hooks convention (throwIfRequestError) — see src/v2/hooks/request-error.js.
export default function usePurchaseOrderDetail(id) {
    return useQuery(
        ["pharmacy-purchase-order-detail", id],
        async () => {
            const result = await request({ url: `inventory/orders/${id}`, method: "GET" });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;
            return body.data;
        },
        { enabled: !!id, retry: false }
    );
}
